<template>
  <a-card class="style1">
    <a-table :loading="isLoading" :columns="columns" :data-source="qrData" size="middle" bordered rowKey="id">
      <div slot="email" slot-scope="text, record">{{ getEmail(record) }}</div>
      <div slot="lastname" slot-scope="text, record">{{ getLastName(record) }}</div>
      <div slot="firstname" slot-scope="text, record">{{ getFirstName(record) }}</div>
      <div slot="slug" slot-scope="record" class="slug" @click="onDownloadQRCode(record)">
        <div v-if="record">
          <qrcode-vue :value="'https://truelife.org/invitation/' + record" :size="150" render-as="svg" :margin="16" level="H" :id="record" class="review-qr-code" />
          <a-button @click="onDownloadQRCode(record)" type="dashed" size="small" style="margin-top: 2px">Download</a-button>
        </div>
        <div v-else>No QR Code</div>
      </div>
      <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
        <a-input
          v-ant-ref="c => (searchInput = c)"
          :placeholder="`Search ${column.title}`"
          :value="selectedKeys[0]"
          style="width: 190px; margin-bottom: 8px; display: block"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm, column.key)"
        />
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px" @click="() => handleSearch(selectedKeys, confirm, column.key)">Search</a-button>
        <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">Reset</a-button>
      </div>
      <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
    </a-table>
  </a-card>
</template>
<script>
import { slugData, empty } from '@/utils';
import { includes } from 'lodash';
import AdminService from '@/services/AdminService';
import Constants from '@/constants.js';
import QrcodeVue from 'qrcode.vue';
export default {
  components: {
    QrcodeVue,
  },
  data() {
    const columns = [
      {
        title: '#ID',
        dataIndex: 'id',
        key: 'id',
        width: 80,
      },
      {
        title: 'First Name',
        dataIndex: 'firstname',
        key: 'firstname',
        scopedSlots: {
          customRender: 'firstname',
        },
      },
      {
        title: 'Last Name',
        dataIndex: 'lastname',
        key: 'lastname',
        scopedSlots: {
          customRender: 'lastname',
        },
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        scopedSlots: {
          customRender: 'email',
        },
      },
      {
        title: 'QR Code',
        dataIndex: 'slug',
        key: 'slug',
        scopedSlots: {
          customRender: 'slug',
        },
        width: 200,
      },
    ].map(item => {
      if (!['slug'].includes(item.key)) {
        return {
          ...item,
          scopedSlots: {
            ...item.scopedSlots,
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
          onFilter: (value, record) => {
            let rr;
            switch (this.searchedColumn) {
              case 'email':
                rr = record.user[this.searchedColumn];
                break;
              case 'firstname':
                rr = record.user[this.searchedColumn];
                break;
              case 'lastname':
                rr = record.user[this.searchedColumn];
                break;
              default:
                rr = record[this.searchedColumn];
            }
            return rr && includes(slugData(rr), slugData(value));
          },
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        };
      }
      return item;
    });
    return {
      form: this.$form.createForm(this),
      qrList: [],
      searching: '',
      error: '',
      isLoading: true,
      isEdit: false,
      isVisibleModal: false,
      isVisibleCardAmountModal: false,
      confirmDirty: false,
      isChangedPass: false,
      qrData: [],
      userEdit: {},
      columns: columns,
    };
  },
  watch: {
    qrList: {
      async handler(val) {
        this.qrData = val;
      },
      immediate: true,
    },
  },
  async created() {
    try {
      this.isLoading = true;
      await this.doInitData();
    } catch (error) {
      console.error({ error });
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    apiURL() {
      return Constants.API_URL;
    },
  },
  methods: {
    empty,
    pageUrl(record) {
      return Constants.APP_URL + `/invitation/${record.slug}`;
    },
    getLastName(record) {
      const { lastname } = record.user;
      return lastname;
    },
    getFirstName(record) {
      const { firstname } = record.user;
      return firstname;
    },
    getEmail(record) {
      return record.user.email;
    },
    async doInitData() {
      await this.fetchData();
    },
    async fetchData(params = {}) {
      this.isLoading = true;

      const data = await AdminService.videos.getQrAll();
      this.qrList = data;
      this.isLoading = false;
    },
    onDownloadQRCode(record) {
      import('@/utils/fileSaver').then(file => {
        file.saveImage(document.querySelector(`#${record} svg`), record, 'svg');
      });
    },
    handleSearch(selectedKeys, confirm, key) {
      confirm();
      this.searchedColumn = key;
    },

    handleReset(clearFilters) {
      clearFilters();
    },
  },
};
</script>
<style lang="scss" scoped>
.review-qr-code {
  svg {
    max-width: 150px !important;
    max-height: 150px !important;
  }
  cursor: pointer;
}
.slug {
  text-align: center;
}
</style>
